export default __webpack_public_path__ + "static/media/stripes-r-bottom.fd30a1f4.png";